export type ActivitySection =
  | 'activityTypes'
  | 'options'
  | 'groups'
  | 'labels'
  | 'date'
  | 'sort';

export type AssetSection = 'groups' | 'columns';

export type AccountSection = 'groups' | 'accountTypes' | 'columns';

export type FilterSectionType = ActivitySection | AssetSection | AccountSection;

export const ACTIVITY_SECTIONS: readonly ActivitySection[] = [
  'activityTypes',
  'options',
  'groups',
  'labels',
  'date',
  'sort',
] as const;

export const ASSET_SECTIONS: readonly AssetSection[] = ['groups', 'columns'] as const;

export const ACCOUNT_SECTIONS: readonly AccountSection[] = [
  'columns',
  'groups',
  'accountTypes',
] as const;
